import { render, staticRenderFns } from "./Inspections.vue?vue&type=template&id=37e8bf90&scoped=true&"
import script from "./Inspections.vue?vue&type=script&lang=ts&"
export * from "./Inspections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e8bf90",
  null
  
)

export default component.exports